import { GetCredentialsListDataItem } from '@/types/my-credentials'
import operatorBg from '@/assets/my-credentails/credentails/cetificate-student-front1.png'
import teacherBg from '@/assets/my-credentails/credentails/teacher.png'
import serviceEngineer from '@/assets/my-credentails/credentails/service_engineer.png'
import deliveryEngineerBg from '@/assets/my-credentails/credentails/delivery_engineer.png'
import noActiveHorn from '@/assets/my-credentails/credentails/no_active_horn.svg'
import teacherHorn from '@/assets/my-credentails/credentails/teacher_horn.svg'
import serviceEngineerHorn from '@/assets/my-credentails/credentails/service_engineer_horn.svg'
import operatorHorn from '@/assets/my-credentails/credentails/operator_horn.svg'
import deliveryEngineerHorn from '@/assets/my-credentails/credentails/delivery_engineer_horn.svg'
import operator_bg_Bg from '@/assets/my-credentails/credentails/operator-bg.png'
import teacher_bg_Bg from '@/assets/my-credentails/credentails/teacher-bg.png'
import teacher_bg_Bg2 from '@/assets/my-credentails/credentails/teacher-bg2.png'
import diaoyun_operator_bg from '@/assets/my-credentails/credentails/diaoyun-operator-bg.jpg'
import serviceEngineer_bg_Bg from '@/assets/my-credentails/credentails/service_engineer-bg.png'
import deliveryEngineerBg_bg_Bg from '@/assets/my-credentails/credentails/delivery_engineer-bg.png'
import agriculturalDeliveryEngineer from '@/assets/my-credentails/credentails/robot-delivery-engineer.png'
import agriculturalServiceEngineer from '@/assets/my-credentails/credentails/robot-service-engineer.png'
import agriculturalDeliveryEngineerBg from '@/assets/my-credentails/credentails/robot-delivery-engineer-bg.png'
import agriculturalServiceEngineerBg from '@/assets/my-credentails/credentails/robot-service-engineer-bg.png'
import roverServiceEngineer from '@/assets/my-credentails/credentails/rover-service-engineer.png'
import roverServiceEngineerBg from '@/assets/my-credentails/credentails/rover-service-engineer-bg.png'
import waitReviewHorn from '@/assets/my-credentails/credentails/wait_review_horn.svg'
import DiaoyunOperator from '@/assets/my-credentails/credentails/diaoyun-operator.png'
import UavFlyOperator from '@/assets/my-credentails/credentails/uavfly-operator.png'
import uavflyOperatorBg from '@/assets/my-credentails/credentails/uavfly-operator-bg.jpg'
import type { CardItemType } from '@/types/my-credentials'

export function getBackgroundHandle(item: CardItemType) {
  console.log('item22', item)
  let url
  switch (item.cardType) {
    case 'operator':
      url = operatorBg
      break
    case 'teacher':
      url = teacherBg
      break
    case 'hoisting_teacher':
      url = teacherBg
      break
    case 'delivery_engineer':
      url = deliveryEngineerBg
      break
    case 'service_engineer':
      url = serviceEngineer
      break
    case 'agricultural_robot_delivery_engineer':
      url = agriculturalDeliveryEngineer
      break
    case 'agricultural_robot_service_engineer':
      url = agriculturalServiceEngineer
      break
    case 'ugv_service_engineer':
      url = roverServiceEngineer
      break
  }
  return url
}

export function getBgBackgroundHandle(type: string) {
  let url
  console.log('type', type)
  switch (type) {
    case 'operator':
      url = uavflyOperatorBg
      break
    case 'teacher':
      url = teacher_bg_Bg
      break
    case 'hoisting_teacher':
      url = teacher_bg_Bg2
      break
    case 'hoisting_operator':
      url = diaoyun_operator_bg
      break
    case 'delivery_engineer':
      url = deliveryEngineerBg_bg_Bg
      break
    case 'service_engineer':
      url = serviceEngineer_bg_Bg
      break
    case 'agricultural_robot_delivery_engineer':
      url = agriculturalDeliveryEngineerBg
      break
    case 'agricultural_robot_service_engineer':
      url = agriculturalServiceEngineerBg
      break
    case 'ugv_service_engineer':
      url = roverServiceEngineerBg
      break
  }
  return url
}

export function getColorHandle(item: CardItemType) {
  let color
  switch (item.cardType) {
    case 'operator':
      color = '#BE1A20'
      break
    case 'teacher':
      color = '#E99313'
      break
    case 'delivery_engineer':
      color = '#426DA9'
      break
    case 'service_engineer':
      color = '#79BE70'
      break
    case 'agricultural_robot_delivery_engineer':
      color = '#426DA9'
      break
    case 'agricultural_robot_service_engineer':
      color = '#79BE70'
      break
    case 'ugv_service_engineer':
      color = '#79BE70'
      break
  }
  return color
}

export function getHorn(item: CardItemType, status: number) {
  let url = noActiveHorn
  if ([0, 1, 3].includes(status) && item.isActive) {
    return waitReviewHorn
  }
  if (!item.isActive) {
    return url
  }
  switch (item.cardType) {
    case 'operator':
      url = operatorHorn
      break
    case 'teacher':
      url = teacherHorn
      break
    case 'hoisting_teacher':
      url = teacherHorn
      break
    case 'delivery_engineer':
      url = deliveryEngineerHorn
      break
    case 'service_engineer':
      url = serviceEngineerHorn
      break
    case 'agricultural_robot_delivery_engineer':
      url = deliveryEngineerHorn
      break
    case 'agricultural_robot_service_engineer':
      url = serviceEngineerHorn
      break
    case 'ugv_service_engineer':
      url = serviceEngineerHorn
      break
  }
  return url
}
export type CardBaseInfoParams =
  | CardItemType
  | {
      type: number // 证件类型
      active: number // 证件是否已点亮
      archive_link?: string // 电子签章pdf
      license_image_url?: string // 未电子签章的图
      license_seal_image_url?: string // 电子签章图片
      can_certificate_apply: number // 是否可以申请电子签章的类型
      is_apply: number // 1 有正在申请的流程  2 没有正在申请的流程
    }
export function judgeCetifateIsUavOperator(type: number | string) {
  return Number(type) === 81
}
export function judgeIsNewUavOperatorCertificate(item: CardBaseInfoParams): boolean {
  return Number(item.type) === 81 || judgeCetifateIsDiaoyunOperater(item)
}
// 判断是否为农业机器人证件（39 交付工程师 40 服务工程师）
export function judgeCetifateIsAgriculturalRobot(item: CardBaseInfoParams | string): boolean {
  const type = Number(typeof item === 'object' ? item.type : item)
  return type === 39 || type === 40
}
// 判断是否为农业无人车证件（42 服务工程师）
export function judgeCetifateIsAgriculturalUnmannedVehicle(
  item: CardBaseInfoParams | string
): boolean {
  const type = Number(typeof item === 'object' ? item.type : item)
  return type === 42
}
// status 2 为审核已通过
export function judgeCetifiacateHasPhoto(photoStatus: number): boolean {
  return photoStatus === 2
}
// 通用证件是否可操作判断逻辑
// 只有四种操作证可以申请身体证件
// 所有证件的是否可以申请实体证件与下载电子证都是头像审核已通过的前提
// 判断-下载电子证
export function judgeCetifateOpearatorDownloadBtnCanLight(
  item: CardBaseInfoParams,
  photoStatus: number
): boolean {
  if (judgeCetifateIsUavOperator(item.type)) {
    // 新版无人机操作证，需要判断是否已经有签章完成，通过 archive_link 字段判断
    return !!item.license_seal_image_url
  }
  if (judgeCetifateIsDiaoyunOperater(item)) {
    return !!item.license_image_url
  }
  if (!judgeCetifiacateHasPhoto(photoStatus)) {
    return false
  }
  // 证件已点亮
  if (item.active !== 1) {
    return false
  }

  return true
}
// 判断是否为吊运操作证
export function judgeCetifateIsDiaoyunOperater(item: CardBaseInfoParams): boolean {
  const type = Number(item.type)
  return type === 37
}
// 判断是否为吊运类型的证件
export function judgeCetifateIsDiaoyunType(item: CardBaseInfoParams): boolean {
  const type = Number(item.type)
  return type === 37 || type === 38
}
// 判断申请实体证件的按钮是否高亮
export function judgeCetifateOpearatorApplyBtnCanLight(
  item: CardBaseInfoParams,
  photoStatus: number
): boolean {
  if (judgeIsNewUavOperatorCertificate(item)) {
    // 新版无人机操作证，需要判断是否已经有签章完成，通过 archive_link 字段判断
    return !!item.license_seal_image_url
  }
  if (judgeCetifateIsDiaoyunType(item)) {
    return false
  }
  if (!judgeCetifiacateHasPhoto(photoStatus)) {
    return false
  }
  // 证件已点亮，证件属于可以申请实体证的类型
  if (item.active !== 1 || item.can_certificate_apply !== 1) {
    return false
  }
  if (judgeIsNewUavOperatorCertificate(item)) {
    // 新版无人机操作证，需要判断是否已经有签章完成，通过 archive_link 字段判断
    return !!item.license_seal_image_url
  }
  return true
}
// 判断申请实体证件能否申请
export function judgeCetifateOpearatorApplyBtnCanUse(
  item: CardBaseInfoParams,
  photoStatus: number
): boolean {
  if (!judgeCetifateOpearatorApplyBtnCanLight(item, photoStatus)) {
    return false
  }
  // 证件没有正在申请中的流程可以申请
  if (item.is_apply !== 2) {
    return false
  }
  return true
}
// 获取新版证件调用渲染的canvas
export async function getRenderOperatperCanvas(data: CardItemType) {
  // 1. 加载图片
  const typeVal = Number(data?.type)
  const bg = typeVal === 81 ? UavFlyOperator : DiaoyunOperator
  const img: HTMLImageElement = await new Promise((resolve, reject) => {
    const i = new Image()
    i.crossOrigin = 'anonymous' // 关键：允许跨域
    i.onload = () => resolve(i)
    i.onerror = () => reject(new Error('图片加载失败或跨域受限'))
    i.src = bg
  })

  // 2. 计算绘制尺寸（保持比例）
  const { width, height } = img

  // 3. 创建离屏 canvas
  const canvas = document.createElement('canvas')
  canvas.width = width
  canvas.height = height
  const ctx = canvas.getContext('2d')
  ctx.drawImage(img, 0, 0, width, height)

  //  设置文字属性
  ctx.font = `24px 'PingFang SC', 'Microsoft Yahei',sans-serif`
  ctx.fillStyle = '#000000'
  // 填写姓名
  ctx.fillText(data.name, 327, 151)
  // 填写性别
  ctx.fillText(data.gender, 327, 200)
  // 填写出生日期
  ctx.fillText(data.birthDay, 528, 200)
  // 填写发证日期
  ctx.fillText(data.createTime, 327, 350)
  // 填写发证机构
  ctx.fillText(data.issuingAuthority, 327, 251)
  // 填写培训机构
  ctx.fillText(data.issuingAuthority, 327, 300)
  // 填写证书编号
  ctx.fillText(data?.code, 150, 396)

  // 4. 导出 blob 并生成本地 URL
  const blob: Blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/png'))
  return URL.createObjectURL(blob)
}
